import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useLocationWithState } from './useLocationWithState';
import { ReactRouterLocationState } from '../appTypings';

interface Props extends NavLinkProps {
  state?: ReactRouterLocationState;
}

export const NavLinkWithHistory = ({ children, state, ...props }: Props) => {
  const location = useLocationWithState();

  return (
    <NavLink {...props} state={{ ...state, from: location }}>
      {children}
    </NavLink>
  );
};
